import React from 'react';
import Thumbnail from './Thumbnail/Thumbnail';
import AudioHotspotPlayer from '../Hotspot/MediaType/AudioHotspot/AudioHotspotPlayer/AudioHotspotPlayer';
import * as constants from '../../constants';
import { appendAutoPlay } from '../../utils/appendIframe';

const MainMediaContent = ({
  alt,
  autoPlay,
  className,
  height,
  id,
  media,
  mediaLibrary,
  mediaType,
  primaryColor,
  transcript,
  videoSrc,
  width,
  src,
}) => {

  if (!id) {
    return null;
  }
  if (mediaType === constants.VIDEOS) {
    return (
      <div
        className={className}
        data-cy={`main-media-content-video-${id}`}
        dangerouslySetInnerHTML={{
          __html: autoPlay ? appendAutoPlay(videoSrc) : videoSrc,
        }}
      />
    );
  }
  if (mediaType === constants.TEXT || mediaType === constants.EMBED) {
    return (
      <div
        className={`media-modal__${mediaType}`}
        dangerouslySetInnerHTML={{
          __html: media.content,
        }}
      />
    );
  }
  if (mediaType === constants.IMAGES && !mediaLibrary) {
    return (
      <div className="media-modal__image-wrapper">
        <img alt={alt} className="media-modal__image" src={media.img} />
      </div>
    );
  }
  if (mediaType === constants.AUDIO && !mediaLibrary) {
    return (
      <AudioHotspotPlayer
        audio={media}
        id={media.id}
        primaryColor={primaryColor}
        transcript={transcript}
      />
    );
  }

  return (
    <Thumbnail
      mediaId={id}
      mediaType={mediaType}
      mediaUrl={src}
      thumbClass={className}
      height={height}
      width={width}
      alt={alt}
      tabIndex={0}
      view
      pad
      noBackground={mediaType === constants.AUDIO && mediaLibrary}
    />
  );
};

export default MainMediaContent;
